"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestraTrayectoria() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="31457" id="compromiso-recla360" ref={ref} className="relative w-full py-24 lg:py-32 overflow-hidden bg-background dark">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611697/img/technical_blueprint_watermark.png)] bg-cover bg-center bg-no-repeat mix-blend-overlay" aria-hidden="true" />

      <div className={`relative z-10 max-w-7xl mx-auto px-6 lg:px-8 flex flex-col lg:flex-row gap-12 lg:gap-24 items-start transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="w-full lg:w-3/5 flex flex-col justify-center space-y-8">
          <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold text-primary font-sans tracking-tighter leading-[1.1] uppercase">Transformamos Empresas&nbsp; con Soluciones Digitales Inteligentes</h2>
          <div className="h-2 w-[80px] bg-secondary rounded-sm" />
        </div>

        {}
        <div className="w-full lg:w-2/5 flex flex-col items-start space-y-8">
          <p className="text-lg md:text-xl text-foreground/90 leading-[1.7] font-sans font-medium">En Recla360 desarrollamos sistemas digitales inteligentes y plataformas automatizadas para empresas técnicas, industriales y comerciales que buscan escalar operaciones, integrar IA y dominar su sector con tecnología avanzada sin complicaciones innecesarias.</p>

          <Button asChild className="bg-secondary hover:bg-secondary/90 text-secondary-foreground rounded-sm px-10 py-7 text-base font-bold shadow-xl shadow-secondary/10 transition-all hover:scale-105 border-b-2 border-secondary-foreground/20">
            <Link to="/HomePage" newTab={false}>
              Nuestra Visión
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}